export const Indicator = {
  getUnit: (indicator) => {
    const name = indicator && indicator.unit && indicator.unit.name;
    if (name === 'Процент') {
      return '%';
    }
    return name;
  }
};
